import { Fragment, useState } from "react";
import { Flex, Text, Select } from "@theorgchartdev/storybook";
import {
  selectWithLabelStyle,
  sectionTitles
} from "../../../../Navigation/Header/WebLinkMenu/WebLinkUtils";
import { SelectableSearchMenu } from "../../../Menus/BasicChartSearchMenu/SelectableSearchMenu";
import { appstr } from "@coreapp/utils/appstr";
import { appstrp } from "@coreapp/utils/appstrp";

const LevelOptions = clickHandler => {
  return [2, 3, 4, 5].map(level => ({
    label: level,
    value: level,
    clickHandler: target => clickHandler("levels", target.value),
    dataTestId: `weblink-startpoint-levels-${level}`
  }));
};

const BuildViewsOptions = (views, clickHandler) => {
  return views.map(view => ({
    label: view.GetTemplateName(),
    value: view.GetTemplateID(),
    clickHandler: target => clickHandler("view", target.value)
  }));
};

export const StartPointSection = ({ views, startPointConfig, setUrlParamsMgr }) => {
  const [searchInput, setSearchInput] = useState(null);
  const SetStartPoint = (key, value) => {
    setUrlParamsMgr(prevState => ({
      ...prevState,
      startPoint: { ...prevState.startPoint, [key]: value }
    }));
  };

  return (
    <Fragment>
      <Flex direction={"column"} gap={"8px"}>
        <Text size={"small"} modifier={"bold"}>
          {appstr(sectionTitles.startingpoint)}
        </Text>
        <Flex {...selectWithLabelStyle} gap={"8px"}>
          <Text size={"small"} modifier={"bold"}>
            {appstr("topbox")}
          </Text>
          <SelectableSearchMenu
            id={"weblink-search"}
            dataTestId={"weblink-startpoint-search"}
            selectedItem={searchInput ? { label: searchInput, id: searchInput } : null}
            onRemoveItem={() => {
              setSearchInput(null);
              SetStartPoint("topBoxID", null);
            }}
            searchMenuProps={{
              clearOnSelect: true,
              inputProps: {
                autoFocus: false
              }
            }}
            optionSize={"small"}
            inputSize={"medium"}
            handleSearchOptionClick={target => {
              const name = target.label || target.result?.Name || target.value;
              setSearchInput(name);
              SetStartPoint("topBoxID", target.value);
            }}
          />
        </Flex>
        <Flex direction={"row"} gap={"8px"}>
          <Flex {...selectWithLabelStyle}>
            <Select
              label={appstr("Levels")}
              placeholder={appstrp("Select", "...")}
              inputOnly={false}
              selectSize={"medium"}
              optionsSize={"small"}
              value={startPointConfig.levels}
              options={LevelOptions(SetStartPoint)}
            />
          </Flex>
          <Flex {...selectWithLabelStyle}>
            <Select
              label={appstr("View")}
              placeholder={appstrp("Select", "...")}
              inputOnly={false}
              selectSize={"medium"}
              optionsSize={"small"}
              value={startPointConfig.view}
              options={BuildViewsOptions(views, SetStartPoint)}
              dataTestId={"weblink-startpoint-view-select"}
            />
          </Flex>
        </Flex>
      </Flex>
    </Fragment>
  );
};
